import React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { FaFileSignature } from 'react-icons/fa';

import './dialogAvisoAssinatura.css';

export default function DialogAvisoAssinatura({
    openDialog,
    setOpenDialog,
    assinante,
}) {
    const close = () => {
        setOpenDialog(false);
    };

    const header = assinante ? 'ASSINATURA DO TITULAR' : 'ASSINATURA DE UMA TESTEMUNHA';

    const footer = (
        <div className="button-container">
            <Button label="Ok" icon="pi pi-check" onClick={close} />
        </div>
    );

    const bodyTitular = (
        <>
            {assinante == 'TITULAR' ? (
                <div className="dialog-pagamento-content">
                    <FaFileSignature color="black" fontSize={50} />
                    <h2>Solicite ao TITULAR sua assinatura!</h2>
                </div>
            ) : (
                <div className="dialog-pagamento-content">
                    <FaFileSignature color="black" fontSize={50} />
                    <h2>Solicite à uma TESTEMUNHA que assine!</h2>
                    <p>
                        *Essa tela é exibida porque o titular tem mais de 65 anos e deve
                        ser colhida a asinatura de uma testemunha
                    </p>
                </div>
            )}
        </>
    );

    return (
        <Dialog
            header={header}
            footer={footer}
            visible={openDialog}
            style={{ width: '50vw' }}
            modal
            onHide={close}
        >
            {bodyTitular}
        </Dialog>
    );
}

